module.exports = __webpack_public_path__ + "static/media/My Video.384a5822.mp4";